<template>
  <div>
    <ToolbarAuth />
    <Navigation />

    <div class="mt-15 ml-15 mr-15">
      <v-card>
        <v-card-title class="primary--text text-uppercase">
          {{ $t("crud.add") }}
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <ValidationObserver ref="obs" v-slot="{ invalid, validate, handleSubmit }">
            <v-form ref="form">
              <v-row>
                <v-col cols="12">
                  <BaseValInput rules="required|max:150" v-model="family_name" v-bind:label="$t('fchart.name')" />
                </v-col>
              </v-row>
              <v-row>
                <v-col sm="12" md="6">
                  <BaseValInput rules="required|max:150" v-model="place" v-bind:label="$t('team.place')" />
                </v-col>
                <v-col sm="12" md="6">
                  <BaseValInput rules="required|max:150" v-model="rel_number" v-bind:label="$t('fchart.rel_nr')" />
                </v-col>
              </v-row>
              <v-row>
                <v-col sm="12" md="6">
                  <ValidationProvider v-bind:name="$t('users.RelMan')" rules="required" v-slot="{ errors, valid }">
                    <v-autocomplete
                      v-bind:placeholder="$t('crud.search')"
                      required
                      :items="users"
                      item-text="first_last"
                      item-value="id"
                      v-bind:label="$t('users.RelMan')"
                      outlined
                      v-model="user_id"
                      :menu-props="{ offsetY: true }"
                      :error-messages="errors"
                      :success="valid"
                    ></v-autocomplete>
                  </ValidationProvider>
                </v-col>
                <v-col sm="12" md="6">
                  <ValidationProvider v-bind:name="$t('crud.lang')" rules="required" v-slot="{ errors, valid }">
                    <v-select
                      required
                      :items="lang"
                      item-text="label"
                      item-value="value"
                      v-bind:label="$t('crud.lang')"
                      outlined
                      v-model="chart_lang"
                      :menu-props="{ offsetY: true }"
                      :error-messages="errors"
                      :success="valid"
                    ></v-select>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row>
                <v-col sm="12" md="6">
                  <v-checkbox v-model="a_module" v-bind:label="$t('fchart.mod_a')" />
                </v-col>
                <v-col sm="12" md="6">
                  <v-checkbox v-model="b_module" v-bind:label="$t('fchart.mod_b')" />
                </v-col>
                <v-col sm="12" md="6">
                  <v-checkbox v-model="c_module" v-bind:label="$t('fchart.mod_c')" />
                </v-col>
                <v-col sm="12" md="6">
                  <v-checkbox v-model="d_module" v-bind:label="$t('fchart.mod_d')" />
                </v-col>
                <v-col sm="12" md="6">
                  <v-checkbox v-model="e_module" v-bind:label="$t('fchart.mod_e')" />
                </v-col>
                <v-col sm="12" md="6"> </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <h4 class="primary--text">{{ $t("fchart.variant") }}
                  <v-icon class="ml-5" color="info" dark @click="showNote = true"
                  >mdi-chat</v-icon
                  >
                  </h4>
                </v-col>
                <ModalOptions :visible="showNote" @close="showNote = false"/>
                <v-col sm="12" md="6">
                  <v-checkbox v-model="f_module" v-bind:label="$t('fchart.mod_f')" />
                </v-col>
                <v-col sm="12" md="6">
                  <v-checkbox v-model="g_module" v-bind:label="$t('fchart.mod_g')" />
                </v-col>
                <v-col sm="12" md="6">
                  <v-checkbox v-model="h_module" v-bind:label="$t('fchart.mod_h')" />
                </v-col>
                <v-col sm="12" md="6">
                  <v-checkbox v-model="i_module" v-bind:label="$t('fchart.mod_i')" />
                </v-col>
                <v-col cols="12">
                  <h4 class="primary--text">===================================================================</h4>
                </v-col>
              </v-row>
              <v-row>
                <v-col sm="12" md="6">
                  <v-checkbox v-model="j_module" v-bind:label="$t('fchart.mod_j')" />
                </v-col>
                <v-col sm="12" md="6">
                  <v-checkbox v-model="k_module" v-bind:label="$t('fchart.mod_k')" />
                </v-col>
                <v-col sm="12" md="6">
                  <v-checkbox v-model="l_module" v-bind:label="$t('fchart.mod_l')" />
                </v-col>
                <v-col sm="12" md="6">
                  <v-checkbox v-model="m_module" v-bind:label="$t('fchart.mod_m')" />
                </v-col>
                <v-col sm="12" md="6">
                  <v-checkbox v-model="n_module" v-bind:label="$t('fchart.mod_n')" />
                </v-col>
                <v-col sm="12" md="6">
                  <v-checkbox v-model="o_module" v-bind:label="$t('fchart.mod_o')" />
                </v-col>
              </v-row>
              <div class="text-end mr-15">
                <v-btn color="accent" @click="closeItem()" class="mr-8">{{ $t("crud.close") }} </v-btn>
                <v-btn color="primary" @click="handleSubmit(saveItem)" :disabled="invalid || !validate || disableBtn">{{ $t("crud.add") }} </v-btn>
              </div>
            </v-form>
          </ValidationObserver>
          <FlashMessage :error="error" v-if="error" key="error" />
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ToolbarAuth from "@/components/navigation/ToolbarAuth";
import Navigation from "@/components/navigation/Navigation";
import BaseValInput from "@/components/input/BaseValInput";
import { ValidationObserver } from "vee-validate";
import FlashMessage from "@/components/input/FlashMessage";
import { getError } from "@/utils/helpers";
import FchartService from "@/services/fchart/FchartService";
import { ValidationProvider } from "vee-validate";
import ModalOptions from "@/components/Fchart/ModalOptions";

export default {
  name: "Users",
  components: {
    ModalOptions,
    FlashMessage,
    BaseValInput,
    ToolbarAuth,
    Navigation,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      showNote: false,
      disableBtn: false,
      error: null,
      chart_lang: "",
      family_name: "",
      place: "",
      rel_number: "",
      user_id: "",
      a_module: false,
      b_module: false,
      c_module: false,
      d_module: false,
      e_module: false,
      f_module: false,
      g_module: false,
      h_module: false,
      i_module: false,
      j_module: false,
      k_module: false,
      l_module: false,
      m_module: false,
      n_module: false,
      o_module: false,
      lang: [
        { label: "Nederlands", value: "nl" },
        { label: "English", value: "en" },
      ],
    };
  },
  methods: {
    saveItem() {
      const payload = {
        family_name: this.family_name,
        place: this.place,
        rel_number: this.rel_number,
        statement_en: this.statement_en,
        user_id: this.user_id,
        chart_lang: this.chart_lang,
        a_module: this.a_module,
        b_module: this.b_module,
        c_module: this.c_module,
        d_module: this.d_module,
        e_module: this.e_module,
        f_module: this.f_module,
        g_module: this.g_module,
        h_module: this.h_module,
        i_module: this.i_module,
        j_module: this.j_module,
        k_module: this.k_module,
        l_module: this.l_module,
        m_module: this.m_module,
        n_module: this.n_module,
        o_module: this.o_module,
      };
      this.error = null;
      this.disableBtn = true;
      FchartService.postMain(payload)
        .then(() => {
          this.$router.replace({ name: "fchartIndex" });
        })
        .catch((error) => (this.error = getError(error)))
        .finally(() => (this.disableBtn = false));
    },

    closeItem() {
      this.$router.replace({ name: "fchartIndex" });
    },
  },
  computed: {
    ...mapGetters("user", ["loading", "users"]),
  },
  created() {
    this.$store.dispatch("user/getUsers");
  },
};
</script>

<style scoped></style>
